<template>
  <svg width="190" height="191" viewBox="0 0 190 191" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_1949_28015)">
      <circle cx="95" cy="85.5407" r="75" fill="white" />
    </g>
    <circle opacity="0.15" cx="95" cy="85.5406" r="75" :fill="color ?? themeColor.hex" />
    <circle cx="150" cy="31" r="18" fill="white" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M150.062 60.125C166.112 60.125 179.125 47.1168 179.125 31.0625C179.125 15.0175 166.112 2 150.062 2C134.013 2 121 15.0175 121 31.0625C121 47.1168 134.013 60.125 150.062 60.125ZM151.849 15.8024C152.323 16.2762 152.589 16.9188 152.589 17.5888V28.5362H163.536C164.206 28.5362 164.849 28.8023 165.323 29.2761C165.796 29.7499 166.062 30.3925 166.062 31.0625C166.062 31.7325 165.796 32.3751 165.323 32.8489C164.849 33.3227 164.206 33.5888 163.536 33.5888H152.589V44.5362C152.589 45.2062 152.323 45.8488 151.849 46.3226C151.375 46.7963 150.733 47.0625 150.062 47.0625C149.392 47.0625 148.75 46.7963 148.276 46.3226C147.802 45.8488 147.536 45.2062 147.536 44.5362V33.5888H136.589C135.919 33.5888 135.276 33.3227 134.802 32.8489C134.329 32.3751 134.062 31.7325 134.062 31.0625C134.062 30.3925 134.329 29.7499 134.802 29.2761C135.276 28.8023 135.919 28.5362 136.589 28.5362H147.536V17.5888C147.536 16.9188 147.802 16.2762 148.276 15.8024C148.75 15.3287 149.392 15.0625 150.062 15.0625C150.733 15.0625 151.375 15.3287 151.849 15.8024Z"
      :fill="color ?? themeColor.hex" />
    <path
      d="M69 56C65.5522 56 62.2456 57.3696 59.8076 59.8076C57.3696 62.2456 56 65.5522 56 69V69.7092C56 70.0771 56.202 70.4153 56.5259 70.5897L93.1038 90.2869C94.2876 90.9244 95.7125 90.9245 96.8963 90.2871L133.474 70.5962C133.798 70.4218 134 70.0836 134 69.7156V69C134 65.5522 132.63 62.2456 130.192 59.8076C127.754 57.3696 124.448 56 121 56H69ZM134 78.5276C134 78.1493 133.596 77.908 133.263 78.0873L96.5405 97.86C96.067 98.1149 95.5377 98.2483 95 98.2483C94.4623 98.2483 93.933 98.1149 93.4595 97.86L56.737 78.0873C56.4039 77.908 56 78.1493 56 78.5276V108C56 111.448 57.3696 114.754 59.8076 117.192C62.2456 119.63 65.5522 121 69 121H121C124.448 121 127.754 119.63 130.192 117.192C132.63 114.754 134 111.448 134 108V78.5276Z"
      :fill="color ?? themeColor.hex" />
    <defs>
      <filter id="filter0_d_1949_28015" x="0" y="0.54068" width="190" height="190" filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.333333 0 0 0 0 0.431373 0 0 0 0 0.901961 0 0 0 0.13 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1949_28015" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1949_28015" result="shape" />
      </filter>
    </defs>
  </svg>
</template>
<script setup>
import {useTheme} from "@/stores/ThemeStore";
import {storeToRefs} from "pinia";

const {color: themeColor} = storeToRefs(useTheme());

const props = defineProps({
    color: {
        type: String,
        required: false
    }
});
</script>
